import sanityClient from '@sanity/client';

export default sanityClient({
    projectId: "qn7x93kl",
    dataset: "production",
    useCdn: true,
    apiVersion: "2022-10-28"
});